import { Navigate } from 'react-router-dom';
import { useUnifiedConsumerNav } from '@/hooks/useUnifiedConsumerNav';
import { useOrgPaths } from '@/hooks/useOrgPaths';

type ClubMemberFeature = 'memberships' | 'courtHire' | 'inventory' | 'notices' | 'any';

interface ClubMemberPortalGuardProps {
  children: React.ReactNode;
  feature?: ClubMemberFeature;
}

/**
 * Redirects users without club member portal access away from club member routes.
 */
export function ClubMemberPortalGuard({ children, feature = 'any' }: ClubMemberPortalGuardProps) {
  const consumerNav = useUnifiedConsumerNav();
  const { p } = useOrgPaths();

  if (!consumerNav.useUnifiedNav) {
    return <>{children}</>;
  }

  const dashboard = p('/dashboard') ?? '/org-picker';

  if (!consumerNav.hasClubMemberAccess) {
    return <Navigate to={dashboard} replace />;
  }

  if (feature === 'memberships' && !consumerNav.hasMemberships) {
    return <Navigate to={dashboard} replace />;
  }
  if (feature === 'courtHire' && !consumerNav.hasCourtHire) {
    return <Navigate to={dashboard} replace />;
  }
  if (feature === 'inventory' && !consumerNav.hasInventoryHire) {
    return <Navigate to={dashboard} replace />;
  }

  return <>{children}</>;
}
